// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/mountain-wave-go-no-go.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/mountain-wave-go-no-go/mountain-wave-go-no-go.js';

mount([g0]);
